import React from "react"

const transparent1x1 = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="

class ImageWithFallback extends React.Component {

  times = 0
  state = {
    noImage: false
  }

  changeSrc = ( newSrc ) => {
    let { src, fallback = "/image/placeholder.png", ...other } = this.props
    if ( !src ) src = fallback
    console.log( `Image Not Found: ${src}` )


    this.times++
    if ( this.times > 2 ) return
    if( typeof(fallback) === "object"){
      this.setState({Child: fallback})
    }
    if ( newSrc === null ) {
      this.setState( { noImage: true } )
      this.element.src = transparent1x1
    } else {
      this.element.src = newSrc
      this.setState( { isFallback: true } )
    }
  }

  render() {
    const {Child} = this.state
    let { src, fallback = "//placehold.it/420x240/f5f5f5/&text=%20", className="", ...other } = this.props
    if ( !src ) src = fallback

    if( Child) return Child
    if ( this.state.noImage ){
      return null
    }

    const { isFallback } = this.state
    let classes = className
    if ( isFallback ) classes += " isFallback"
    return (
      <img src={src}
           className={classes}
           onError={() => this.changeSrc( fallback )}
           ref={el => this.element = el}
           {...other} />
    )
  }
}


export default ImageWithFallback



// WEBPACK FOOTER //
// ./src/components/ImageWithFallback.js